<template>
    <main class="main">
        <MainContent />
        <MainWek />
    </main>
</template>

<script>
import MainContent from './MainContent.vue';
import MainWek from './MainWek.vue';

export default {
    components: { MainContent, MainWek }
}
</script>

